import React, { useState } from "react";
import { FiTrash } from "react-icons/fi";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";

const ItemGrid = ({ shelves, searchQuery }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);

  console.log(shelves);

  const updateMutation = useUpdateItem(ApiEndPoint.PHARMACY);

  const openDeleteModal = (boxId, itemId, batchId, location) => {
    setSelectedBatch({ boxId, itemId, batchId, location });
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedBatch(null);
    setModalOpen(false);
  };

  const handleDeleteBatch = () => {
    if (!selectedBatch) return;
    const { boxId, itemId, batchId, location } = selectedBatch;
    const updatedLocation = location.filter((loc) => loc !== boxId);

    updateMutation.mutate(
      {
        data: {
          action: "patchBatch",
          id: batchId,
          location: updatedLocation,
        },
      },
      {
        onSuccess: () => {
          toast.success("Great! Batch Is Removed From The Location");
        },
        onError: () => {
          toast.error(
            "Sorry! There is an issue removing the Batch from the location"
          );
        },
      }
    );
    closeModal();
  };

  return (
    <>
      {shelves?.map((shelf) => (
        <div key={shelf.id} className="mb-8">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">
            {shelf.shelf_name}
          </h3>
          <p className="text-gray-500 text-sm mb-4">
            Subcategory:{" "}
            <span className="font-medium">{shelf.shelf_category || "N/A"}</span>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {shelf?.boxes?.map((box) => (
              <div
                key={box.id}
                className="p-5 bg-white border border-gray-200 rounded-lg shadow-lg hover:shadow-xl transition-shadow relative"
              >
                <h5 className="text-lg font-bold text-gray-700 mb-4">
                  {box.box_name}
                </h5>

                <ul className="space-y-4">
                  {box.items?.length > 0 ? (
                    box.items
                      .filter(
                        (item) =>
                          item.items_name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          item?.batches.some((batch) =>
                            batch?.batch_no
                              .toLowerCase()
                              .includes(searchQuery.toLowerCase())
                          )
                      )
                      .map((item) => (
                        <li
                          key={item.id}
                          className="p-4 bg-gray-50 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition"
                        >
                          <div className="text-gray-800 font-medium mb-2">
                            {item.items_name}
                          </div>

                          <div className="space-y-2">
                            {item.batches.map((batch) => (
                              <div
                                key={batch.id}
                                className="p-3 bg-white border border-gray-100 rounded-md shadow-xs relative"
                              >
                                {/* Delete Button - Positioned Top Right */}
                                <button
                                  onClick={() =>
                                    openDeleteModal(
                                      box.id,
                                      item.id,
                                      batch.id,
                                      batch.location
                                    )
                                  }
                                  className="absolute top-2 right-2 text-red-500 hover:text-red-700 transition p-1"
                                  title="Delete Batch"
                                >
                                  <FiTrash size={16} />
                                </button>

                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">Batch No:</span>{" "}
                                  {batch.batch_no}
                                </div>
                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">
                                    Receive Date:
                                  </span>{" "}
                                  {new Date(
                                    batch.receive_date
                                  ).toLocaleDateString()}
                                </div>
                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">
                                    Expiry Date:
                                  </span>{" "}
                                  {new Date(
                                    batch.expiry_date
                                  ).toLocaleDateString()}
                                </div>
                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">
                                    Available Quantity:
                                  </span>{" "}
                                  {batch.quantity}
                                </div>
                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">
                                    Received Quantity:
                                  </span>{" "}
                                  {batch.received_quantity}
                                </div>
                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">MRP:</span> ₹
                                  {batch.price}
                                </div>
                                <div className="text-sm text-gray-700">
                                  <span className="font-medium">
                                    Batch Price:
                                  </span>{" "}
                                  ₹{batch.batch_price}
                                </div>
                              </div>
                            ))}
                          </div>
                        </li>
                      ))
                  ) : (
                    <div className="p-6 text-center text-gray-400 text-lg border border-dashed border-gray-300 rounded-lg bg-gray-50">
                      No items available in this box
                    </div>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Confirmation Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-96">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Confirm Deletion
            </h2>
            <p className="text-gray-600 mb-4">
              Are you sure you want to remove this batch location?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteBatch}
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ItemGrid;
